// extracted by mini-css-extract-plugin
export default {"crLoadingOverlay":"CrLoadingOverlay_crLoadingOverlay__vQPdB","opaque":"CrLoadingOverlay_opaque__dB3iC"};